<template>
  <div class="m-input" :class="class_list">
    <van-field
      :value="value"
      @input="(val) => $emit('input', val)"
      @focus="focus = true"
      @blur.prevent="
        (e) => {
          focus = false
          $emit('blur')
        }
      "
      @dblclick.prevent
      :label="label"
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled="disabled"
      :readonly="readonly"
      :type="type"
    >
      <template #button>
        <slot name="button"></slot>
      </template>
      <template #right-icon>
        <slot name="right-icon"></slot>
      </template>
    </van-field>
  </div>
</template>

<script>
export default {
  props: {
    value: String | Number,
    label: String,
    type: String,
    placeholder: String,
    clearable: Boolean,
    disabled: Boolean,
    readonly: Boolean,
  },
  computed: {
    class_list() {
      const arr = []
      if (this.disabled) {
        arr.push('disabled')
      } else if (this.readonly) {
        arr.push('readonly')
      } else if (this.focus) {
        arr.push('focus')
      }
      return arr.join(' ')
    },
  },
  mounted() {
    this._val = this.value
  },
  data() {
    return {
      focus: false,
      changed: false,
    }
  },
}
</script>

<style lang="less" scoped>
.m-input {
  // ...
  background: #daedff;
  border-radius: 4px;
  padding-left: 6px;
  border: 1px solid #fff;
  box-sizing: border-box;
  &.readonly {
    background: #fff;
  }
  /deep/ .van-cell {
    background: transparent;
  }
}
</style>
